import React from "react";
import {
  // HiXCircle,
  BiReset,
  // MdSkipPrevious,
  // MdExitToApp
} from "react-icons/bi";
import { useTranslation } from "react-i18next";

export default function ResetButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button  is-small modal-button ${
          props.disabled ? "button-disabled" : ""
        }`}
        onClick={props.onClickHandler}
        title={t("Reset")}
      >
        <span className="has-text-light mr-2">{ t("Reset")}</span>
        <span className="icon  has-text-light">
          <BiReset className="fas fa-2x" />
        </span>
      </button>
    </>
  );
}
